import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "star-rating" }

import { ref } from "vue";
import Star from "./Star.vue";

interface Props {
  hoverRating: number;
  rating: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StarRating',
  props: {
    hoverRating: {},
    rating: {}
  },
  emits: ["rating", "hover-rating"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const stars = ref<number>(5);

function setHoverRating(event: any, index: number) {
  emit("hover-rating", {
    event: event,
    hoverRating: index,
  });
}

function setRating(index: number) {
  emit("rating", {
    rating: index,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stars.value, (index) => {
      return (_openBlock(), _createBlock(Star, {
        key: index,
        index: index,
        hoverRating: __props.hoverRating,
        rating: __props.rating,
        onSetHoverRating: ($event: any) => (setHoverRating($event, index)),
        onClick: ($event: any) => (setRating(index))
      }, null, 8, ["index", "hoverRating", "rating", "onSetHoverRating", "onClick"]))
    }), 128))
  ]))
}
}

})